import { SimpleCollection, Collection } from 'src/types';
import ImageWithFallback from 'src/components/ImageWithFallback';
import { truncate, escapeRegExp } from 'lodash-es';
import { AppRoutes } from 'src/lib/routes';
import Link from 'next/link';
import useBreakpoints from 'src/hooks/useBreakpoints';
import Highlighter from 'react-highlight-words';


type Props = {
  title?: string;
  position?: number;
  collection: Collection | SimpleCollection;
  className?: string;
  onClick?: (collection: Collection | SimpleCollection) => void;
  descLength?: number;
  imageClassName?: string;
  titleClassName?: string;
  descClassName?: string;
  highlightText?: string;
};

const CollectionHorizontalCard: React.FC<Props> = ({
  title,
  collection,
  position,
  className,
  onClick,
  descLength,
  imageClassName,
  titleClassName,
  descClassName,
  highlightText
}) => {
  const { isScreenMd } = useBreakpoints()
  const actualDescLength = descLength || (isScreenMd ? 100 : 80)
  const url = 'slugCode' in collection ? AppRoutes.collectionRoute({ id: collection.slugCode }).toUrl() : collection.url
  return (
    <Link legacyBehavior prefetch={false} href={url}>
      <a
        onClick={(e) => {
          if (onClick) {
            e.preventDefault()
            onClick(collection)
          }
        }}
        className={`tw-flex tw-items-center tw-text-brand-navy ${className || ''}`}
      >
        <div className={`${imageClassName || 'tw-w-28 md:tw-w-64 tw-h-28 md:tw-h-48'} tw-relative tw-flex-shrink-0 tw-flex-grow-0`}>
          <ImageWithFallback
            record={collection.image}
            imgField="webpMdUrl"
            fill
            className="tw-object-cover tw-rounded-lg tw-border-2 tw-border-solid tw-border-brand-green"
            alt={collection.name}
          />

          {position ? (
            <div className="tw-absolute tw-top-3 tw-left-3 tw-w-8 tw-h-8 tw-bg-white tw-text-brand-navy tw-rounded-full tw-leading-8 tw-text-center">
              {position}
            </div>
          ) : null}
        </div>
        <div className="tw-ml-5">
          <div className="tw-mb-1">
            <Highlighter
              searchWords={escapeRegExp(highlightText).split(' ')}
              textToHighlight={title || collection.name}
              className={titleClassName || 'tw-font-styleSans tw-font-semibold md:tw-text-lg'}
            />
          </div>
          <div>
            <Highlighter
              searchWords={escapeRegExp(highlightText).split(' ')}
              className={descClassName || ''}
              textToHighlight={truncate(collection.strippedDescription, { length: actualDescLength, omission: '...' })}
              />
          </div>
        </div>
      </a>
    </Link>
  );
};

export default CollectionHorizontalCard;
